import { Mutation, MutationTree } from 'vuex'
import { State } from './state'
import { ProductAggregatedStatDeklaracjeSum } from "@/store/modules/statsDeklaracje/types";
import _ from 'lodash'
import {ObjectDataWithPaginator} from "@/store/modules/dashboard/types";


export function updatingAggregatedStatsDeklaracjeSum(state: State,  forceUpdate: boolean = false) {
    state.aggregatedStatsDeklaracjeSumUpdating = true;
    state.aggregatedStatsDeklaracjeSumBuffer = (forceUpdate) ? [] : state.aggregatedStatsDeklaracjeSum;
}

export function updatedAggregatedStatsDeklaracjeSum(state: State) {
    state.aggregatedStatsDeklaracjeSumUpdating = false;
    state.aggregatedStatsDeklaracjeSum = _.sortBy(state.aggregatedStatsDeklaracjeSumBuffer, o => o.productId);
    state.aggregatedStatsDeklaracjeSumBuffer = [];
}

export function loadedAggregatedStatsDeklaracjeSumForProduct(state: State, productStat: ProductAggregatedStatDeklaracjeSum) {
    state.aggregatedStatsDeklaracjeSumBuffer.push(productStat);
}

export function loadingDetailedStatsDeklaracjeBetweenDatesForProduct(state: State) {
    state.detailedStatsDeklaracjeLoading = true;
}

export function loadedDetailedStatsDeklaracjeForProduct(state: State, data: Array<object>) {
    state.detailedStatsDeklaracjeLoading = false;
    state.detailedStatsDeklaracje = data as Array<object>;
}

export default <MutationTree<State>> {
    updatingAggregatedStatsDeklaracjeSum,
    updatedAggregatedStatsDeklaracjeSum,
    loadedAggregatedStatsDeklaracjeSumForProduct,
    loadingDetailedStatsDeklaracjeBetweenDatesForProduct,
    loadedDetailedStatsDeklaracjeForProduct
}
